<!-- Title -->
<h1 mat-dialog-title>
  {{ 'addarea' | translate }}
</h1>

<!-- Content -->
<div mat-dialog-content>
  <form [formGroup]="form" fxLayout="column" class="form-with-hints">

    <!-- Name -->
    <mat-form-field appearance="standard">
      <mat-label>{{ 'name' | translate }}</mat-label>
      <input matInput formControlName="name">
      <mat-hint>{{ 'areaHintName' | translate }}</mat-hint>
      <mat-error *ngIf="form.get('name').hasError('required')">{{ 'fieldrequired' | translate }}</mat-error>
      <mat-error *ngIf="form.get('name').hasError('unique')">{{ 'areaErrorNameNotUnique' | translate }}</mat-error>
    </mat-form-field>

    <!-- Area template -->
    <mat-form-field appearance="standard">
      <mat-label>{{ 'template' | translate }}</mat-label>
      <mat-select formControlName="basicAreaId">
        <mat-option *ngFor="let areaTemplate of areaTemplates" [value]="areaTemplate._id">
          {{ areaTemplate.name }}
        </mat-option>
      </mat-select>
      <mat-hint>{{ 'areaHintTemplate' | translate }}</mat-hint>
    </mat-form-field>

    <!-- Quantity -->
    <mat-form-field appearance="standard">
      <mat-label>{{ 'quantity' | translate }}</mat-label>
      <input matInput formControlName="quantity" type="number" min="0" step="1">
      <mat-hint>{{ 'areaHintQuantity' | translate }}</mat-hint>
      <mat-error *ngIf="form.get('quantity').hasError('min')">{{ 'fieldNotNegative' | translate }}</mat-error>
      <mat-error *ngIf="form.get('quantity').hasError('pattern')">{{ 'fieldDecimalsNone' | translate }}</mat-error>
      <mat-error *ngIf="form.get('quantity').hasError('required')">{{ 'fieldrequired' | translate }}</mat-error>
    </mat-form-field>

    <!-- Height -->
    <mat-form-field appearance="standard">
      <mat-label>{{ 'minimalheight' | translate }}</mat-label>
      <input matInput formControlName="height" type="number" min="0" step="0.01">
      <span matSuffix>m</span>
      <mat-hint>{{ 'areaHintHeight' | translate }}</mat-hint>
      <mat-error *ngIf="form.get('height').hasError('min')">{{ 'fieldNotNegative' | translate }}</mat-error>
      <mat-error *ngIf="form.get('height').hasError('pattern')">{{ 'fieldDecimalsMax2' | translate }}</mat-error>
    </mat-form-field>

    <!-- Surface -->
    <mat-form-field appearance="standard">
      <mat-label>{{ 'surface' | translate }}</mat-label>
      <input matInput formControlName="surface" type="number" min="0" step="0.01">
      <span matSuffix>m<sup>2</sup></span>
      <mat-hint>{{ 'areaHintSurface' | translate }}</mat-hint>
      <mat-error *ngIf="form.get('surface').hasError('min')">{{ 'fieldNotNegative' | translate }}</mat-error>
      <mat-error *ngIf="form.get('surface').hasError('required')">{{ 'fieldrequired' | translate }}</mat-error>
      <mat-error *ngIf="form.get('surface').hasError('pattern')">{{ 'fieldDecimalsMax2' | translate }}</mat-error>
    </mat-form-field>

    <!-- Occupation -->
    <mat-form-field appearance="standard">
      <mat-label>{{ 'expectedoccupation' | translate }}</mat-label>
      <input matInput formControlName="occupation" type="number" min="0" step="1">
      <span matSuffix>{{ 'person' | translate: 'pluralLowerCase' }}</span>
      <mat-hint>{{ 'areaHintOccupation' | translate }}</mat-hint>
      <mat-error *ngIf="form.get('occupation').hasError('min')">{{ 'fieldNotNegative' | translate }}</mat-error>
      <mat-error *ngIf="form.get('occupation').hasError('pattern')">{{ 'fieldDecimalsNone' | translate }}</mat-error>
    </mat-form-field>

    <!-- Comment -->
    <mat-form-field appearance="standard">
      <mat-label>{{ 'comment' | translate }}</mat-label>
      <input matInput formControlName="comment">
      <mat-hint>{{ 'areaHintComment' | translate }}</mat-hint>
    </mat-form-field>

  </form>
</div>

<!-- Actions -->
<div mat-dialog-actions align="end">
  <button mat-button tabindex="-1" (click)="dialogRef.close()">
    {{ 'cancel' | translate }}
  </button>
  <button mat-flat-button (click)="submit()" tabindex="-1" [color]="'primary'" [disabled]="form.invalid">
    {{ 'add' | translate }}
  </button>
</div>
